import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ReadInvoiceParams {
  from: string;
  to: string;
  cust?: number | null;
  proj?: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class ReadInvoiceService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get<T = unknown>(params: ReadInvoiceParams): Observable<T[]> {
    let httpParams = new HttpParams();

    if (params.cust) httpParams = httpParams.set('cust', String(params.cust));
    if (params.proj) httpParams = httpParams.set('proj', String(params.proj));

    return this.http.get<any[]>(`/api/readinvoice/${params.from}/${params.to}`, {
      params: httpParams,
    });
  }
}
